import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { PaymentsProvider } from "../../context/PaymentsContext";
import PaymentsListPage from "./PaymentsListPage";
import PaymentSetupPage from "./PaymentSetupPage";

const PaymentsRoutes: React.FC = () => {
  return (
    <Routes>
      <Route index element={<PaymentsListPage />} />
      <Route path="setup" element={<PaymentSetupPage />} />
      {/* Legacy paths — payments module uses Xonder */}
      <Route path="payments" element={<Navigate to="/payments" replace />} />
      <Route path="invoices" element={<Navigate to="/payments" replace />} />
      <Route path="billing" element={<Navigate to="/payments" replace />} />
      <Route path="account" element={<Navigate to="/payments" replace />} />
    </Routes>
  );
};

const PaymentsLayout: React.FC = () => {
  return (
    <PaymentsProvider>
      <PaymentsRoutes />
    </PaymentsProvider>
  );
};

export default PaymentsLayout;
